const redeemGiftCardTranslationConfig = {
  common: ['CommonUI.Controls', 'CommonUI.Features'],
  feature: 'Purchasing.RedeemGameCard'
};

export default redeemGiftCardTranslationConfig;
